'use client';

import useIsMobile from 'src/hooks/useIsMobileScreenSize';
import React, { ReactNode } from 'react';
import { cm } from 'src/utils/classNames';
import Button from 'src/components/primitives/Button/Button';
import { WithRef } from 'src/utils/UtilityTypes';

type TableActionButtonProps = {
	handleClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
	label: string | ReactNode;
	key?: string;
	hideOnMobile?: boolean;
	disabled?: boolean;
	className?: string;
	buttonClassName?: string;
	isLoading?: boolean;
};

const TableActionButton = ({
	handleClick,
	label,
	key,
	hideOnMobile,
	disabled,
	className,
	buttonClassName,
	ref,
	isLoading,
	...props
}: WithRef<TableActionButtonProps, HTMLDivElement>) => {
	const isMobile = useIsMobile();

	if (hideOnMobile && isMobile) return null;

	return (
		<div
			ref={ref}
			key={key}
			className={cm('flex items-center justify-center px-2 py-2', className)}
			{...props}
		>
			<Button
				size="sm"
				variant="secondary"
				className={buttonClassName}
				onClick={(e) => {
					e.stopPropagation();
					handleClick(e);
				}}
				disabled={disabled}
				isLoading={isLoading}
			>
				{label}
			</Button>
		</div>
	);
};

TableActionButton.displayName = 'TableActionButton';

export default TableActionButton;
